<div class="field">
  @if (label) {
    <div>
      <label
        class="bold"
        [id]="'lbl' + question_id"
        for="{{ question_id }}"
        [attr.aria-label]="label"
        style="display: inline"
        [attr.aria-hidden]="displayHelpText"
        >
        <span [hidden]="hide_label">{{ label }}</span>
      </label>
      @if (displayHelpText) {
        <button
          tabindex="-1"
          aria-pressed="false"
          type="button"
          class="help"
          title="more info"
          placement="top-left"
          [attr.aria-label]="label"
          [ngbPopover]="popoverContent"
          >
          ?
        </button>
      }
      <ng-template #popoverContent>
        <div class="popoverTitle">More Info:</div>
        <div id="popoverContent" class="popoverContent" role="tooltip">
          {{ help_text }}
        </div>
      </ng-template>
    </div>
  }
  <div [formGroup]="paramFormGroup">
    @if (!required) {
      <span class="optional-text">(Optional)</span>
    }
    @if (readOnly) {
      <div>
        <label>{{ value }}</label>
      </div>
    } @else {
      <input
        #input
        [class.error]="isInvalid"
        [value]="value"
        [attr.id]="question_id"
        [id]="question_id"
        [attr.aria-label]="getAriaLabel()"
        [name]="code"
        [attr.name]="code"
        autocomplete="{{ isautocomplete ? 'on' : 'off' }}"
        [type]="fieldType"
        [pattern]="pattern"
        [formControl]="inputControl"
        [placeholder]="placeholder === null ? '' : placeholder"
        [minlength]="minlength"
        [maxlength]="maxlength"
        [min]="min"
        [max]="max"
        attr.data-cy="{{ code }}"
        />
      }
    </div>
    @if (isInvalid) {
      <div class="">
        <p [class.error]="isInvalid">{{ error_text }}</p>
      </div>
    }
  </div>
